import { api } from "src/api/endpoints"

export const getUsersCaps = () => {
    return async (dispatch) => {
        try {
            const { data, status } = await api.get('/usersCaps/getCaps')
            dispatch({
                type: "getCaps",
                payload: data
            })
        } catch (e) {}
    }
}